import React from "react";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import PropTypes from "prop-types";

import styles from "./CarousalArrow.module.scss";

const CarousalArrow = ({ showArrows, sliderRef }) => {
  if (!showArrows) return null;

  return (
    <div className={styles.customArrows}>
      <IconButton
        size="small"
        onClick={() => sliderRef.current?.slickPrev()}
        aria-label="Previous"
      >
        <ArrowBackIosNew fontSize="small" />
      </IconButton>
      <IconButton
        size="small"
        onClick={() => sliderRef.current?.slickNext()}
        aria-label="Next"
      >
        <ArrowForwardIos fontSize="small" />
      </IconButton>
    </div>
  );
};

CarousalArrow.propTypes = {
  showArrows: PropTypes.bool.isRequired,
  sliderRef: PropTypes.shape({
    current: PropTypes.shape({
      slickPrev: PropTypes.func,
      slickNext: PropTypes.func,
    }),
  }).isRequired,
};

export default CarousalArrow;
